//Components
import Button from "../../Button/Button";
//Styles
import styles from "./ContactUsToast.module.scss";
//Amplitude
import * as amplitude from "@amplitude/analytics-browser";

const ContactUsToast = () => {
  const handleClickButton = () => {
    const buttonClickedEvent = {
      event_type: "Button Clicked",
      display_name: "Button Clicked",
      event_properties: {
        page_name: "eComm - Pricing",
        button_name: "Contact us",
      },
    };

    amplitude.track(buttonClickedEvent);

    window.open("https://magnapest.com/contact-us");
  };

  return (
    <div className={styles.root}>
      <p className={styles.text}>
        Something failed. Please try again or contact us so we can help with
        your pest needs.
      </p>
      <Button type="toast" onClick={() => handleClickButton()}>
        <p className={styles.buttonText}>CONTACT US</p>
      </Button>
    </div>
  );
};

export default ContactUsToast;
